"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatLocalDateTime = formatLocalDateTime;
/**
 * `formatLocalDateTime` — the ONE instant→display formatter for pass field
 * values. Renders an ISO-8601 instant as `YYYY-MM-DD HH:mm` in a fixed DISPLAY
 * time zone (Europe/Budapest by default — the demo market). Replaces the two
 * private `getUTC*`-based formatters that rendered the UTC calendar day (and a
 * misleading " UTC" suffix), which showed +1 day for any flight whose local
 * date differs from the UTC date. TZ-env independent (explicit `timeZone`), so
 * CI's TZ=UTC and a laptop's TZ agree byte-for-byte.
 *
 * OFFSET-LESS date-times (`2026-05-01T08:00[:ss[.sss]]`) carry no instant —
 * `new Date(iso)` would pin them to the HOST zone, making the rendering vary
 * with the TZ env and contradicting the byte-for-byte claim above. They are
 * interpreted as WALL TIME in the display time zone instead, which formats to
 * itself — so they are rendered verbatim (`timeZone` is not consulted on this
 * path, and an invalid `timeZone` therefore does not throw for them).
 *
 * A non-parseable `iso` is returned verbatim, but an invalid `timeZone` throws
 * a RangeError from the Intl.DateTimeFormat constructor.
 */
const DEFAULT_DISPLAY_TZ = 'Europe/Budapest';
// `YYYY-MM-DDTHH:mm[:ss[.sss]]` with NO trailing offset — a wall time.
const OFFSETLESS_DATETIME_RE = /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})(?::\d{2}(?:\.\d+)?)?$/;
function formatLocalDateTime(iso, timeZone = DEFAULT_DISPLAY_TZ) {
    const wall = OFFSETLESS_DATETIME_RE.exec(iso);
    if (wall !== null) {
        const [, date = '', time = ''] = wall;
        return `${date} ${time}`;
    }
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return iso;
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    }).formatToParts(d);
    const get = (type) => parts.find((p) => p.type === type)?.value ?? '';
    return `${get('year')}-${get('month')}-${get('day')} ${get('hour')}:${get('minute')}`;
}
//# sourceMappingURL=formatLocalDateTime.js.map